export default __webpack_public_path__ + "static/media/technical-books.d02fa6c5.svg";